import { all, call, put, select, takeLatest } from "redux-saga/effects";
import queryApi from "../../utils/fetchApi";
import Urler from "../../utils/serviceUrl";
import { selectCurrentUser } from "./user.selector";
import userActionTypes from "./user.types";

import {
  fetchUserCoinsFailure,
  fetchUserCoinsSuccess,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  logInFailure,
  logInSuccess,
  resendValidationEmailFailure,
  resendValidationEmailSuccess,
  resetPasswordFailure,
  resetPasswordSuccess,
  signOutFailure,
  signOutSuccess,
  signUpFailure,
  signUpSuccess,
  syncUserDataFailure,
  syncUserDataSuccess,
  updateProfileDataFailure,
  updateProfileDataSuccess,
  updateProfileDataValidate,
  uploadUserPhotosFailure,
  uploadUserPhotosSuccess,
  verifyEmailFailure,
  verifyEmailSuccess,
} from "./user.actions";

import {
  clearGlobalState,
  errorInit,
  loaderMiniRemove,
  loaderRemove,
  messageInit,
} from "../globals/global.actions";

export function* logIn({ payload: { email, password } }) {
  console.log("checking credentials");
  console.log(email, password);
  try {
    let res = yield queryApi({
      method: "POST",
      data: { email, password },
      url: yield Urler("/users/login"),
    });
    if (res.status === "success") {
      let {
        token,
        data: { user },
      } = res;
      yield all([
        put(logInSuccess({ token, userData: user })),
        put(loaderRemove(false)),
      ]);
    } else {
      console.log("res", res);
      if (res.message === "Please Verify Your Email Address") {
        let res1 = yield queryApi({
          method: "POST",
          data: { email },
          url: yield Urler("/users/resendValidationEmail"),
        });
        if (res1.status === "success") {
          //note i am using signUpSuccess here because there is no need to create a verifyEmailSuccess action and action type since both their successes do the same thing
          yield all([
            put(
              signUpSuccess({ message: res1.message, messageType: "signUp" }),
            ),
            put(loaderRemove(false)),
          ]);
        } else {
          yield all([
            put(logInFailure({ error: res1.message, errorType: "login" })),
            put(loaderRemove(false)),
          ]);
        }
      } else {
        yield all([
          put(logInFailure({ error: res.message, errorType: "login" })),
          put(loaderRemove(false)),
        ]);
      }
    }
  } catch (e) {
    yield all([
      put(logInFailure({ error: e.message, errorType: "login" })),
      put(loaderRemove(false)),
    ]);
  }
}

export function* verifyEmail({ payload: { email, password, OTP } }) {
  console.log("OTP", OTP);
  try {
    let res = yield queryApi({
      method: "POST",
      data: { email, password, OTP },
      url: yield Urler("/users/verifyEmail"),
    });
    if (res.status === "success") {
      let {
        token,
        data: { user },
      } = res;
      yield all([
        put(verifyEmailSuccess({ token, userData: user })),
        put(loaderRemove(false)),
      ]);
    } else {
      yield all([
        put(
          verifyEmailFailure({ error: res.message, errorType: "verifyEmail" }),
        ),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(verifyEmailFailure({ error: e.message, errorType: "verifyEmail" })),
      put(loaderRemove(false)),
    ]);
  }
}

export function* signUp({
  payload: { name, email, password, passwordConfirm },
}) {
  try {
    console.log(name, email);
    let resp = yield queryApi({
      method: "POST",
      data: { name, email, password, passwordConfirm },
      url: yield Urler("/users/signUp"),
    });
    if (resp.status === "success") {
      yield all([
        put(signUpSuccess({ message: resp.message, messageType: "signUp" })),
        put(loaderRemove(false)),
      ]);
    } else {
      yield all([
        put(signUpFailure({ error: resp.message, errorType: "signUp" })),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(signUpFailure({ error: e.message, errorType: "signUp" })),
      put(loaderRemove(false)),
    ]);
  }
}

export function* signOut({ payload: { token } }) {
  try {
    let res = yield queryApi({
      method: "POST",
      bearer: token,
      url: yield Urler("/users/logout"),
    });
    if (res.status === "success") {
      yield all([
        put(signOutSuccess()),
        put(loaderRemove(false)),
        put(clearGlobalState()),
      ]);
    } else {
      yield all([
        put(signOutFailure({ error: res.message, errorType: "logout" })),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(signOutFailure({ error: e.message, errorType: "logout" })),
      put(loaderRemove(false)),
    ]);
  }
}

export function* resendValidationEmail({ payload: { email } }) {
  try {
    console.log(`resend email ${email}`, typeof email);
    let resp = yield queryApi({
      method: "POST",
      data: { email },
      url: yield Urler("/users/resendValidationEmail"),
    });
    console.log("response", resp);
    if (resp.status === "success") {
      console.log("hi success");
      yield all([
        put(
          resendValidationEmailSuccess({
            message: resp.message,
            messageType: "resendValidationEmail",
          }),
        ),
        put(loaderMiniRemove(false)),
      ]);
    } else {
      console.log("hi failure");
      yield all([
        put(
          resendValidationEmailFailure({
            error: resp.message || "There was an error",
            errorType: "resendValidationEmail",
          }),
        ),
        put(loaderMiniRemove(false)),
      ]);
    }
  } catch (e) {
    console.log("hi failure2", e);
    yield all([
      put(
        resendValidationEmailFailure({
          error: e.message,
          errorType: "resendValidationEmail",
        }),
      ),
      put(loaderMiniRemove(false)),
    ]);
  }
}
export function* forgotPassword({ payload: email }) {
  try {
    let resp = yield queryApi({
      method: "POST",
      data: { email: email },
      url: yield Urler("/users/forgotPassword"),
    });
    if (resp.status === "success") {
      yield all([
        put(
          forgotPasswordSuccess({
            message: resp.message,
            messageType: "forgotPassword",
          }),
        ),
        put(loaderRemove(false)),
      ]);
    } else {
      yield all([
        put(
          forgotPasswordFailure({
            error: resp.message,
            errorType: "forgotPassword",
          }),
        ),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(
        forgotPasswordFailure({
          error: e.message,
          errorType: "forgotPassword",
        }),
      ),
      put(loaderRemove(false)),
    ]);
  }
}

export function* resetPassword({
  payload: { email, password, OTP, passwordConfirm },
}) {
  console.log("checking payload in the sagas", {
    email,
    password,
    OTP,
    passwordConfirm,
  });
  if (passwordConfirm !== password) {
    yield all([
      put(
        resetPasswordFailure({
          error: "Password don't match",
          errorType: "resetPassword",
        }),
      ),
      put(loaderRemove(false)),
    ]);
  } else {
    try {
      let res = yield queryApi({
        method: "PATCH",
        data: { email, password, OTP },
        url: yield Urler("/users/resetPassword"),
      });

      if (res.status === "success") {
        let {
          token,
          data: { user },
        } = res;
        yield all([
          put(resetPasswordSuccess({ token, userData: user })),
          put(loaderRemove(false)),
        ]);
      } else {
        yield all([
          put(
            resetPasswordFailure({
              error: res.message,
              errorType: "resetPassword",
            }),
          ),
          put(loaderRemove(false)),
        ]);
      }
    } catch (e) {
      yield all([
        put(
          resetPasswordFailure({
            error: e.message,
            errorType: "resetPassword",
          }),
        ),
        put(loaderRemove(false)),
      ]);
    }
  }
}

export function* userPhotoUpload({
  payload: { token, uploadType, imageUrls },
}) {
  console.log("in sagas");
  console.log(uploadType, imageUrls);
  try {
    let res = yield queryApi({
      method: "PUT",
      data: imageUrls,
      url: yield Urler(`/users/updateProfilePics`),
      bearer: token,
    });
    if (res.status === "Success") {
      let {
        data: { photoBig, photoSmall },
      } = res;
      yield all([
        put(uploadUserPhotosSuccess({ photoBig, photoSmall })),
        put(loaderRemove(false)),
      ]);
    } else {
      yield all([
        put(
          uploadUserPhotosFailure({
            error: res.message,
            errorType: "uploadUserPhotos",
          }),
        ),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(
        uploadUserPhotosFailure({
          error: e.message,
          errorType: "uploadUserPhotos",
        }),
      ),
      put(loaderRemove(false)),
    ]);
  }
}

export function* updateProfileData({ payload: { token, data } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      data,
      url: yield Urler(`/users/updateMe`),
      bearer: token,
    });
    if (res.status === "success") {
      if (!!res.userData) {
        let { userData } = res;
        yield all([
          put(updateProfileDataSuccess({ userData })),
          put(loaderRemove(false)),
        ]);
      } else {
        let { message } = res;
        yield all([
          put(
            updateProfileDataValidate({
              message: message,
              messageType: "updateProfileDataValidate",
            }),
          ),
          put(loaderRemove(false)),
        ]);
      }
    } else {
      yield all([
        put(
          updateProfileDataFailure({
            error: res.message,
            errorType: "updateProfileData",
          }),
        ),
        put(loaderRemove(false)),
      ]);
    }
  } catch (e) {
    yield all([
      put(
        updateProfileDataFailure({
          error: e.message,
          errorType: "updateProfileData",
        }),
      ),
      put(loaderRemove(false)),
    ]);
  }
}

export function* fetchUserCoins({ payload: token }) {
  try {
    let res = yield queryApi({
      method: "GET",
      url: yield Urler("/coins/me"),
      bearer: token,
    });
    if (res.status === "Success") {
      let coins = res.data.myCoins[0] ? res.data.myCoins[0].coins : 0;
      yield put(fetchUserCoinsSuccess(coins));
    } else {
      yield put(
        fetchUserCoinsFailure({ error: res.message, errorType: "fetchCoins" }),
      );
    }
  } catch (e) {
    yield put(
      fetchUserCoinsFailure({ error: e.message, errorType: "fetchCoins" }),
    );
  }
}

export function* checkUserSession() {
  try {
    const currentUser = yield select(selectCurrentUser);
    if (currentUser && currentUser.token) {
      const res = yield queryApi({
        method: "GET",
        url: yield Urler("/users/me"),
        bearer: currentUser.token,
      });
      // Only log out if we get a clear authentication error
      // Check for specific auth-related error messages
      const isAuthError =
        res.status === "fail" &&
        (res.message?.includes("Login") ||
          res.message?.includes("Token") ||
          res.message?.includes("Expired") ||
          res.message?.includes("no Longer Exists"));
      if (isAuthError) {
        yield put(signOutSuccess());
      }
    }
  } catch (e) {
    // Don't automatically log out on network errors
    // User might just have connectivity issues
    console.log("Session check failed:", e.message);
  }
}

export function* syncUserData({ payload: token }) {
  try {
    const res = yield queryApi({
      method: "GET",
      url: Urler("users/me"),
      bearer: token,
    });
    if (res.status === "success" && res.data && res.data.data) {
      yield put(syncUserDataSuccess(res.data.data));
    } else {
      yield put(syncUserDataFailure(res.message || "Failed to sync user data"));
    }
  } catch (e) {
    yield put(syncUserDataFailure(e.message));
  }
}

export function* initMessage({ payload: { message, messageType } }) {
  yield put(messageInit({ message, messageType }));
}

export function* initError({ payload: { error, errorType } }) {
  yield put(errorInit({ error, errorType }));
}

/********* */
//listeners
export function* onUpdateProfileDataStart() {
  yield takeLatest(
    userActionTypes.UPDATE_PROFILE_DATA_START,
    updateProfileData,
  );
}

export function* onFetchUserCoinsStart() {
  yield takeLatest(userActionTypes.FETCH_USER_COINS_START, fetchUserCoins);
}

export function* onUpdateProfileDataFailure() {
  yield takeLatest(userActionTypes.UPDATE_PROFILE_DATA_FAILURE, initError);
}

export function* onUpdateProfileDataValidate() {
  yield takeLatest(userActionTypes.UPDATE_PROFILE_DATA_VALIDATE, initMessage);
}

export function* onUploadUserPhotosStart() {
  yield takeLatest(userActionTypes.UPLOAD_USER_PHOTOS_START, userPhotoUpload);
}

export function* onUploadUserPhotosFailure() {
  yield takeLatest(userActionTypes.UPLOAD_USER_PHOTOS_FAILURE, initError);
}

export function* onResetPasswordStart() {
  yield takeLatest(userActionTypes.RESET_PASSWORD_START, resetPassword);
}

export function* onResetPasswordFailure() {
  yield takeLatest(userActionTypes.RESET_PASSWORD_FAILURE, initError);
}

export function* onResendValidationEmailStart() {
  yield takeLatest(
    userActionTypes.RESEND_VALIDATION_EMAIL_START,
    resendValidationEmail,
  );
}

export function* onResendValidationEmailFailure() {
  yield takeLatest(userActionTypes.RESEND_VALIDATION_EMAIL_FAILURE, initError);
}

export function* onResendValidationEmailSuccess() {
  yield takeLatest(
    userActionTypes.RESEND_VALIDATION_EMAIL_SUCCESS,
    initMessage,
  );
}

export function* onForgotPasswordStart() {
  yield takeLatest(userActionTypes.FORGOT_PASSWORD_START, forgotPassword);
}

export function* onForgotPasswordSuccess() {
  yield takeLatest(userActionTypes.FORGOT_PASSWORD_SUCCESS, initMessage);
}

export function* onForgotPasswordFailure() {
  yield takeLatest(userActionTypes.FORGOT_PASSWORD_FAILURE, initError);
}

export function* onSignOutFailure() {
  yield takeLatest(userActionTypes.SIGN_OUT_FAILURE, initError);
}

export function* onVerifyEmailFailure() {
  yield takeLatest(userActionTypes.VERIFY_EMAIL_FAILURE, initError);
}

export function* onLogInFailure() {
  yield takeLatest(userActionTypes.LOG_IN_FAILURE, initError);
}

export function* onSignUpSuccess() {
  yield takeLatest(userActionTypes.SIGN_UP_SUCCESS, initMessage);
}

export function* onSignUpFailure() {
  yield takeLatest(userActionTypes.SIGN_UP_FAILURE, initError);
}

export function* onLogInStart() {
  yield takeLatest(userActionTypes.LOG_IN_START, logIn);
}

export function* onUserSignOutStart() {
  yield takeLatest(userActionTypes.SIGN_OUT_START, signOut);
}

export function* onVerifyEmailStart() {
  yield takeLatest(userActionTypes.VERIFY_EMAIL_START, verifyEmail);
}

export function* onSignUpStart() {
  yield takeLatest(userActionTypes.SIGN_UP_START, signUp);
}

export function* onCheckUserSession() {
  yield takeLatest(userActionTypes.CHECK_USER_SESSION, checkUserSession);
}

export function* onSyncUserDataStart() {
  yield takeLatest(userActionTypes.SYNC_USER_DATA_START, syncUserData);
}

//end of  listeners
/************ */

export function* userSagas() {
  yield all([
    call(onLogInStart),
    call(onUserSignOutStart),
    call(onSignUpStart),
    call(onVerifyEmailStart),
    call(onSignUpSuccess),
    call(onSignUpFailure),
    call(onVerifyEmailFailure),
    call(onSignOutFailure),
    call(onLogInFailure),
    call(onForgotPasswordStart),
    call(onForgotPasswordSuccess),
    call(onForgotPasswordFailure),
    call(onResetPasswordStart),
    call(onResetPasswordFailure),
    call(onResendValidationEmailFailure),
    call(onResendValidationEmailStart),
    call(onResendValidationEmailSuccess),
    call(onUploadUserPhotosFailure),
    call(onUploadUserPhotosStart),
    call(onUpdateProfileDataStart),
    call(onUpdateProfileDataFailure),
    call(onUpdateProfileDataValidate),
    call(onFetchUserCoinsStart),
    call(onCheckUserSession),
    call(onSyncUserDataStart),
  ]);
}
